export default __webpack_public_path__ + "static/media/arrowDown-light.e7d3b965.svg";